import React, { ReactElement, useCallback, useEffect, useMemo } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getUser, selectUsers, UserType } from '../../store/reducers/homeSlice';
import { RootState } from '../../store/reducers';
import moment from 'moment';
import { useHistory } from 'react-router';
import styles from './index.module.scss';
import WealthieBreadCrumb from '../../components/BreadCrumb';
import withLoading from '../../helpers/withLoadingHOC';

const breadcrumbConfig = [{ name: 'Wealthie' }, { name: 'User' }];

function UserAccount(): ReactElement {
  const history = useHistory();
  const dispatch = useDispatch();

  const navigateToDetail = useCallback(
    (userId?: string) => () => {
      history.push(`/users/${userId}`);
    },
    [history],
  );

  const collumns = useMemo(
    () => [
      {
        title: 'Id',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: 'First Name',
        dataIndex: 'first_name',
        key: 'first_name',
        render: function renderFirstName(text: string, row: UserType) {
          return <a onClick={navigateToDetail(row.id)}>{text}</a>;
        },
      },
      {
        title: 'Last Name',
        dataIndex: 'last_name',
        key: 'last_name',
        render: function renderLastName(text: string, row: UserType) {
          return <a onClick={navigateToDetail(row.id)}>{text}</a>;
        },
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
      },
      {
        title: 'Updated Date',
        dataIndex: 'updated_at',
        key: 'updated_at',
        render: function renderLastName(udpatedDate: string) {
          return <div>{moment(udpatedDate).format('DD/MM/YYYY HH:mm:ss')}</div>;
        },
      },
    ],
    [navigateToDetail],
  );

  const users = useSelector((state: RootState) => selectUsers(state));
  useEffect(() => {
    dispatch(getUser());
  }, [dispatch]);

  return (
    <>
      <WealthieBreadCrumb breadcrumbConfig={breadcrumbConfig} />
      <div
        className={styles.site_layout_background}
        style={{ padding: 24, minHeight: 360 }}
      >
        <Table
          data-testid="user_account_page"
          rowKey="id"
          columns={collumns}
          dataSource={users || []}
        />
      </div>
    </>
  );
}

export default withLoading(UserAccount);
